// extracted by mini-css-extract-plugin
export default {"pricingInput":"PricingStep_pricingInput__jjDjl"};